import * as React from 'react';
import { memo } from 'react';

const SvgPeekIcon = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 36 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M21.596 0v25.674m0 0H0m21.596 0L35 37", stroke: "currentColor", strokeWidth: 2 })));
const Memo = memo(SvgPeekIcon);

export { Memo as default };
